/**
 * Copy for Responder per-channel policy and knowledge settings.
 */
export const enResponder = {
  // ── Per-channel mode + the knowledge it answers from (Assistant settings) ──
  'responder.settings.heading': 'Responder',
  'responder.settings.explain':
    'Who answers first on each channel. Off: only your flows and you. Suggest: it drafts, you send. Auto (info): it answers questions on its own and hands anything else to you. Auto (policy): it may also book, send the catalog or discount within the limits you set.',
  'responder.settings.channel.instagram': 'Instagram DM',
  'responder.settings.channel.messenger': 'Messenger',
  'responder.settings.channel.whatsapp': 'WhatsApp',
  'responder.settings.mode.OFF': 'Off',
  'responder.settings.mode.SUGGEST': 'Suggest',
  'responder.settings.mode.AUTO_INFO': 'Auto (info)',
  'responder.settings.mode.AUTO_POLICY': 'Auto (policy)',
  'responder.settings.modeSaved': 'Saved.',
  'responder.settings.modeFailed': 'Could not save that. Try again.',
  'responder.settings.loadFailed': 'Could not load the Responder settings.',
  'responder.knowledge.heading': 'What it knows',
  'responder.knowledge.explain':
    'Answers come from here. Import a spreadsheet of questions and answers, or add one at a time. Pricing, how to sign up, what the product does — anything a customer asks.',
  'responder.knowledge.importCsv': 'Import questions & answers (CSV)',
  'responder.knowledge.csvHint':
    'Columns: question, answer, and optionally kind. Hebrew headers (שאלה, תשובה) work too. Up to 500 rows.',
  'responder.knowledge.importing': 'Importing…',
  'responder.knowledge.imported': '{imported} added, {duplicates} already there, {skipped} skipped.',
  'responder.knowledge.importFailed': 'That file could not be imported.',
  'responder.knowledge.addTitle': 'Question or title',
  'responder.knowledge.addBody': 'Answer',
  'responder.knowledge.add': 'Add',
  'responder.knowledge.addFailed': 'Could not add that.',
  'responder.knowledge.empty': 'Nothing yet. It will only answer from what is here and from your policies.',
  'responder.knowledge.remove': 'Remove',
  'responder.knowledge.count': '{count} documents',
} as const;
